import React from "react";

export const BorderStar = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38 38" fill="none">
      <g clipPath="url(#clip0_2308_17616)">
        <path
          d="M13.6716 27.3758L19.1059 23.9226L24.5403 27.4213L23.117 20.8784L27.9044 16.5164L21.6075 15.9258L19.1059 9.74635L16.6044 15.8803L10.3075 16.471L15.0949 20.8784L13.6716 27.3758ZM9.74679 33.0763L12.2186 21.8639L3.96094 14.325L14.8559 13.329L19.1059 2.75635L23.3559 13.329L34.2509 14.325L25.9933 21.8639L28.4651 33.0763L19.1059 27.1278L9.74679 33.0763Z"
          fill="#FEB312"
        />
      </g>
      <defs>
        <clipPath id="clip0_2308_17616">
          <rect width="37.3906" height="37.3906" fill="white" transform="translate(0.410156)" />
        </clipPath>
      </defs>
    </svg>
  );
};
